export const PAGE_SIZE = 25;

export enum PaymentModel {
  UnverifiedACHTransfer = "UnverifiedACHTransfer",
  UnverifiedACHTransaction = "UnverifiedACHTransaction",
  SwiftWireTransaction = "SwiftWireTransaction",
  WireTransaction = "WireTransaction",
}

// TODO: add translations for web/mobile
export const DisplayStatus = {
  pending_approval: "Pending approval",
  scheduled: "Scheduled",
  in_progress: "In progress",
  processing: "Processing",
  completed: "Completed",
  failed: "Failed",
  canceled: "Canceled",
  unknown: "Pending",
};

export const EMPTY_FILTER_QUERY = {
  state_in: [],
  institution_account_in: [],
  amount_gte: undefined,
  amount_lte: undefined,
  scheduled_date_before: undefined,
  scheduled_date_after: undefined,
  calendar_key: undefined,
  parent: undefined,
  frequency: [],
  payment_speed_in: [],
  bulk_payment: undefined,
  bulk_reversal: undefined,
  wire_import_batch: undefined,
  payment_type_in: [],
  type_in: [],
  direction_in: [],
  template_version: [],
  template: undefined,
};
